(function (root) {
  'use strict';
  const duration = (value) => Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : 0;
  const parseAnchor = (value) => {
    const match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.(\d{3}))?(Z|[+-]\d{2}:\d{2})$/);
    if (!match) return NaN;
    const [, year, month, day, hour, minute, second = '00', milliseconds = '000', offset] = match;
    const y = Number(year), m = Number(month), d = Number(day), h = Number(hour), n = Number(minute), s = Number(second);
    const date = new Date(Date.UTC(y, m - 1, d, h, n, s));
    if (y < 1970 || m < 1 || m > 12 || date.getUTCFullYear() !== y || date.getUTCMonth() !== m - 1 || date.getUTCDate() !== d || h > 23 || n > 59 || s > 59) return NaN;
    if (offset !== 'Z') {
      const oh = Number(offset.slice(1, 3)), om = Number(offset.slice(4));
      if (oh > 14 || om > 59 || (oh === 14 && om !== 0)) return NaN;
    }
    return Date.parse(`${year}-${month}-${day}T${hour}:${minute}:${second}.${milliseconds}${offset}`);
  };
  const configuredDate = (date) => {
    if (!date) return NaN;
    const offset = Number(date.offset);
    if (!Number.isFinite(offset) || offset < -12 || offset > 14) return NaN;
    const minutes = Math.round(Math.abs(offset) * 60);
    const pad = (v) => String(v).padStart(2, '0');
    return parseAnchor(`${date.year}-${pad(date.month)}-${pad(date.day)}T${pad(date.hour)}:${pad(date.minute)}:00${offset < 0 ? '-' : '+'}${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`);
  };
  const evaluate = (config, now = Date.now()) => {
    const invalid = {status: 'invalid', phase: 0, remaining: 0};
    if (config.mode === 'sequence' && !String(config.anchor || '').trim()) return invalid;
    const start = config.anchor ? parseAnchor(config.anchor) : configuredDate(config.date);
    if (!Number.isFinite(start) || !Number.isFinite(now)) return invalid;
    const mode = config.mode || 'standard';
    if (mode === 'standard') return {status: now >= start ? 'expired' : 'running', phase: 1, remaining: Math.max(0, start - now)};
    const first = duration(config.first), second = duration(config.second);
    if (!first || (mode === 'sequence' && !second) || !['evergreen', 'sequence'].includes(mode)) return invalid;
    if (now < start) return {status: 'pending', phase: 0, remaining: 0};
    let elapsed = now - start;
    if (mode === 'evergreen') return {status: 'running', phase: 1, remaining: first - (elapsed % first)};
    const total = first + second;
    if (config.after === 'repeat_all') elapsed %= total;
    if (elapsed < first) return {status: 'running', phase: 1, remaining: first - elapsed};
    if (config.after === 'repeat_second') return {status: 'running', phase: 2, remaining: second - ((elapsed - first) % second)};
    if (elapsed < total) return {status: 'running', phase: 2, remaining: total - elapsed};
    return {status: 'expired', phase: 2, remaining: 0};
  };
  const parts = (remaining) => {
    const seconds = Math.max(0, Math.ceil(Number(remaining) / 1000) || 0);
    return [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map((v) => String(v).padStart(2, '0'));
  };
  root.SNAnnouncementClock = Object.freeze({evaluate, parts});
  if (!root.customElements || root.customElements.get('sn-announcement-clock')) return;
  class SNAnnouncementClockElement extends HTMLElement {
    connectedCallback() {
      if (this.timer || this.syncOff) return;
      const boot = () => {
        if (!this.isConnected || this.timer || this.syncOff) return;
        this.fields = Array.from(this.querySelectorAll('[data-sn-value]'));
        if (this.fields.length !== 4) return;
        this.units = this.querySelector('[data-sn-units]');
        this.note = this.querySelector('[data-sn-note]');
        try { this.config = JSON.parse(this.dataset.config || '{}'); } catch { this.config = {}; }
        this.tick();
        if(root.SNCountdownSync?.enabled)this.syncOff=root.SNCountdownSync.subscribe(this,()=>this.tick());else this.timer = root.setInterval(() => this.tick(), 1000);
      };
      boot();
      if (!this.timer && !this.syncOff) {
        this.observer = new MutationObserver(boot);
        this.observer.observe(this, {childList: true, subtree: true});
      }
    }
    disconnectedCallback() {
      root.clearInterval(this.timer);this.syncOff?.();this.syncOff=null;
      this.timer = null;
      if (this.observer) this.observer.disconnect();
    }
    tick() {
      if (this.observer) this.observer.disconnect();
      const sync = root.SNCountdownSync?.enabled ? root.SNCountdownSync : null;
      const state = sync ? sync.state() : evaluate(this.config);if(sync)sync.paint(this,state);
      this.dataset.status = state.status;
      this.dataset.phase = String(state.phase);
      this.hidden = sync ? state.hidden : state.status === 'expired' && this.dataset.endBehavior === 'hide';
      const showMessage = !sync && state.status === 'expired' && this.dataset.endBehavior === 'message';
      if (this.units) this.units.hidden = showMessage;
      if (this.note) this.note.hidden = !showMessage;
      const values = state.status === 'invalid' || state.status === 'pending' ? ['--', '--', '--', '--'] : parts(state.remaining);
      this.fields.forEach((el, index) => { if (el.textContent !== values[index]) el.textContent = values[index]; });
    }
  }
  root.customElements.define('sn-announcement-clock', SNAnnouncementClockElement);
})(typeof window !== 'undefined' ? window : globalThis);
